import { render } from "./FrisbuyGalleryPagination.vue?vue&type=template&id=1a30d299&scoped=true"
import script from "./FrisbuyGalleryPagination.vue?vue&type=script&lang=js"
export * from "./FrisbuyGalleryPagination.vue?vue&type=script&lang=js"

import "./FrisbuyGalleryPagination.vue?vue&type=style&index=0&id=1a30d299&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a30d299"]])

export default __exports__